import AirportTransfer, { airportTransfer } from './airport-transfer';
import ProductModal from './common/components/ProductModal';
import ProductBundle from './ancillary-bundle/containers/ProductBundleContainer';
import AirHelp, { airHelp } from './air-help';
import MutuallyExclusive, { mutuallyExclusive } from './mutually-exclusive';
import CancelForAnyReason, { cancelForAnyReason } from './cancel-for-any-reason';
import BaggageService, { baggageService } from './baggage-service';
import CabinBaggage, { cabinBaggage } from './baggage-section/cabin-baggage';
import CabinUpgrade, { cabinUpgrade } from './cabin-upgrade';
import secondBaggagePerTraveler from './baggage-section/second-baggage';
import CancellationGuarantee, { cancellationGuarantee } from './cancellation-guarantee';
import CancellationInsideEu, { cancellationInsideEu } from './cancellation-inside-eu';
import CancellationOutsideEu, { cancellationOutsideEu } from './cancellation-outside-eu';
import { checkInBaggage, CheckInBaggage, CheckInBaggagePersuasionModal, NotAvailableCheckInBaggage } from './baggage-section/check-in-baggage';
import { climateCompensation, ClimateCompensationNotification } from './climate-compensation';
import CancelTwentyFourHours, { cancelTwentyFourHours } from './cancel-twenty-four-hours';
import FlexibleTicket, { flexibleTicket } from './flexible-ticket';
import TravelInsuranceCoverGenius, { travelInsuranceCoverGenius } from './travel-insurance-cover-genius';
import Meal, { meal } from './meal';
import MobileTravelPlan, { mobileTravelPlan } from './mobile-travel-plan';
import OnlineCheckIn, { onlineCheckIn } from './online-check-in';
import { ancillaryBundle } from './ancillary-bundle';
import { ProductCard, ProductCardBlock, ProductCardList } from './product-card';
import ProductIcon from './common/components/ProductIcon';
import ProductModalHeader from './common/components/ProductModalHeader';
import { SeatMapWrapper, seatMap } from './seat-map';
import SeatMapContent from './seat-map/page/containers/SeatMapContentContainer';
import ServicePackage, { servicePackage } from './service-package';
import SingleChoice, { singleChoice } from './single-choice';
import Sms, { sms } from './sms';
import TravelDocsPost, { travelDocsPost } from './travel-docs-post';
import TravelInsuranceInsideEu, { travelInsuranceInsideEu } from './travel-insurance/inside-eu/index';
import TravelInsuranceOutsideEu, { travelInsuranceOutsideEu } from './travel-insurance/outside-eu/index';
import ConnectionGuarantee, { connectionGuarantee } from './connection-guarantee';
import TripCancellationProtection, { tripCancellationProtection } from './manulife/trip-cancellation-protection';
import AllInclusiveProtection, { allInclusiveProtection } from './manulife/all-inclusive-protection';
import SimpleVisa, { simpleVisa } from './simple-visa';
import Platinum, { platinum } from './platinum';
import SeatMapModalProvider, { useSeatMapModal } from './common/context/SeatMapModalContext';
import Co2Compensation, { co2Compensation } from './co2-compensation';
import * as productItems from './products';
import { getProductPictogramId } from './common/utils/icon/getProductImageryIds';
import BankruptcyInsuranceCoverGenius, { bankruptcyInsuranceCoverGenius } from './bankruptcy-insurance-cover-genius';
import CancellationInsuranceCoverGenius, { cancellationInsuranceCoverGenius } from './cancellation-insurance-cover-genius';
import ComprehensiveInsuranceCoverGenius, { comprehensiveInsuranceCoverGenius } from './comprehensive-insurance-cover-genius';
import FastTrack, { fastTrack } from './fast-track';
import { validateFastTrackAvailabilityTranslation } from './fast-track/components/utils';
import { validateLoungeAvailabilityTranslation } from './lounge/utils';
import { ProductCardLayoutType } from './common/models/product';
import { getUpsellProps } from './common/utils/productCardProps';
import { SELECTBOX_VALUE } from './common/utils/selectBoxOptions';
import QPass, { qPass } from './q-pass';
import PersonalItem from './baggage-section/personal-item/components/PersonalItem';
import { BAGGAGE_VALUES } from './baggage-section/common/utils/baggageUtils';
import Lounge, { lounge } from './lounge';
import getTranslatedTexts from './common/text-resolvers/utils/getTranslatedTexts';
import { getAvailabilityList, getCartAvailability, withParseAvailability } from './common/utils/availability';
const ClimateCompensation = () => null;
const productIds = {
  ...Object.values({
    ...productItems
  }).reduce((acc, val) => ({
    ...acc,
    [val.id]: val.name
  }), {})
};
export { airHelp, AirHelp, airportTransfer, AirportTransfer, allInclusiveProtection, AllInclusiveProtection, ProductBundle, ancillaryBundle, baggageService, BaggageService, bankruptcyInsuranceCoverGenius, BankruptcyInsuranceCoverGenius, cabinBaggage, CabinBaggage, cabinUpgrade, CabinUpgrade, cancelForAnyReason, CancelForAnyReason, cancellationGuarantee, CancellationGuarantee, cancellationInsideEu, CancellationInsideEu, cancellationInsuranceCoverGenius, CancellationInsuranceCoverGenius, cancellationOutsideEu, CancellationOutsideEu, checkInBaggage, CheckInBaggagePersuasionModal, climateCompensation, ClimateCompensation, ClimateCompensationNotification, comprehensiveInsuranceCoverGenius, ComprehensiveInsuranceCoverGenius, connectionGuarantee, ConnectionGuarantee, cancelTwentyFourHours, CancelTwentyFourHours, co2Compensation, Co2Compensation, fastTrack, FastTrack, flexibleTicket, FlexibleTicket, getProductPictogramId, meal, Meal, mobileTravelPlan, MobileTravelPlan, mutuallyExclusive, MutuallyExclusive, NotAvailableCheckInBaggage, onlineCheckIn, OnlineCheckIn, lounge, Lounge, PersonalItem, Platinum, platinum, ProductCard, ProductCardBlock, ProductCardList, ProductIcon, productIds, productItems, ProductModalHeader, ProductModal, qPass, QPass, seatMap, SeatMapWrapper, SeatMapContent, SeatMapModalProvider, secondBaggagePerTraveler, servicePackage, ServicePackage, simpleVisa, SimpleVisa, singleChoice, SingleChoice, sms, Sms, travelDocsPost, TravelDocsPost, travelInsuranceCoverGenius, TravelInsuranceCoverGenius, travelInsuranceInsideEu, TravelInsuranceInsideEu, travelInsuranceOutsideEu, TravelInsuranceOutsideEu, tripCancellationProtection, TripCancellationProtection, useSeatMapModal };
export const AIR_HELP = {
  ...airHelp,
  component: AirHelp
};
export const ALL_INCLUSIVE_PROTECTION = {
  ...allInclusiveProtection,
  component: AllInclusiveProtection
};
export const TRIP_CANCELLATION_PROTECTION = {
  ...tripCancellationProtection,
  component: TripCancellationProtection
};
export const BAGGAGE_SERVICE = {
  ...baggageService,
  component: BaggageService
};
export const BANKRUPTCY_INSURANCE_COVER_GENIUS = {
  ...bankruptcyInsuranceCoverGenius,
  component: BankruptcyInsuranceCoverGenius
};
export const CABIN_BAGGAGE = {
  ...cabinBaggage,
  component: CabinBaggage
};
export const CABIN_UPGRADE = {
  ...cabinUpgrade,
  component: CabinUpgrade
};
export const CHECK_IN_BAGGAGE = {
  ...checkInBaggage,
  component: CheckInBaggage
};
export const CANCEL_FOR_ANY_REASON = {
  ...cancelForAnyReason,
  component: CancelForAnyReason
};
export const CANCELLATION_GUARANTEE = {
  ...cancellationGuarantee,
  component: CancellationGuarantee
};
export const CANCELLATION_INSIDE_EU = {
  ...cancellationInsideEu,
  component: CancellationInsideEu
};
export const CANCELLATION_INSURANCE_COVER_GENIUS = {
  ...cancellationInsuranceCoverGenius,
  component: CancellationInsuranceCoverGenius
};
export const CANCELLATION_OUTSIDE_EU = {
  ...cancellationOutsideEu,
  component: CancellationOutsideEu
};
export const COMPREHENSIVE_INSURANCE_COVER_GENIUS = {
  ...comprehensiveInsuranceCoverGenius,
  component: ComprehensiveInsuranceCoverGenius
};
export const CANCEL_24_HOURS = {
  ...cancelTwentyFourHours,
  component: CancelTwentyFourHours
};
export const CO2_COMPENSATION = {
  ...co2Compensation,
  component: Co2Compensation
};
export const MOBILE_TRAVEL_PLAN = {
  ...mobileTravelPlan,
  component: MobileTravelPlan
};
export const ONLINE_CHECK_IN = {
  ...onlineCheckIn,
  component: OnlineCheckIn
};
export const SMS = {
  ...sms,
  component: Sms
};
export const TRAVEL_INSURANCE_COVER_GENIUS = {
  ...travelInsuranceCoverGenius,
  component: TravelInsuranceCoverGenius
};
export const TRAVEL_INSURANCE_INSIDE_EU = {
  ...travelInsuranceInsideEu,
  component: TravelInsuranceInsideEu
};
export const TRAVEL_INSURANCE_OUTSIDE_EU = {
  ...travelInsuranceOutsideEu,
  component: TravelInsuranceOutsideEu
};
export const SIMPLE_VISA = {
  ...simpleVisa,
  component: SimpleVisa
};
export const CLIMATE_COMPENSATION = {
  ...climateCompensation,
  component: ClimateCompensation,
  notificationComponent: ClimateCompensationNotification
};
export const TRAVEL_DOCS_POST = {
  ...travelDocsPost,
  component: TravelDocsPost
};
export const SECOND_BAGGAGE_PER_TRAVELER = {
  ...secondBaggagePerTraveler,
  component: () => null
};
export const MUTUALLY_EXCLUSIVE = {
  ...mutuallyExclusive,
  component: MutuallyExclusive
};
export const FAST_TRACK = {
  ...fastTrack,
  component: FastTrack
};
export const ANCILLARY_BUNDLE = {
  ...ancillaryBundle,
  component: ProductBundle
};
export const FLEXIBLE_TICKET = {
  ...flexibleTicket,
  component: FlexibleTicket
};
export const MEAL = {
  ...meal,
  component: Meal
};
export const PLATINUM_SERVICE = {
  ...platinum,
  component: Platinum
};
export const QPASS = {
  ...qPass,
  component: QPass
};
export const SEAT_MAP = {
  ...seatMap,
  component: SeatMapWrapper
}; // TODO: "any" to be addressed when seat map is migrated to TypeScript

export const LOUNGE = {
  ...lounge,
  component: Lounge
};
export const AIRPORT_TRANSFER = {
  ...airportTransfer,
  component: AirportTransfer
};
export const productConstants = {
  AIR_HELP,
  AIRPORT_TRANSFER,
  ALL_INCLUSIVE_PROTECTION,
  BAGGAGE_SERVICE,
  BANKRUPTCY_INSURANCE_COVER_GENIUS,
  CABIN_BAGGAGE,
  CABIN_UPGRADE,
  CANCEL_24_HOURS,
  CANCEL_FOR_ANY_REASON,
  CANCELLATION_GUARANTEE,
  CANCELLATION_INSIDE_EU,
  CANCELLATION_INSURANCE_COVER_GENIUS,
  CANCELLATION_OUTSIDE_EU,
  CHECK_IN_BAGGAGE,
  CLIMATE_COMPENSATION,
  COMPREHENSIVE_INSURANCE_COVER_GENIUS,
  CO2_COMPENSATION,
  FAST_TRACK,
  FLEXIBLE_TICKET,
  LOUNGE,
  MEAL,
  MOBILE_TRAVEL_PLAN,
  ONLINE_CHECK_IN,
  PLATINUM_SERVICE,
  QPASS,
  SEAT_MAP,
  SECOND_BAGGAGE_PER_TRAVELER,
  SIMPLE_VISA,
  SMS,
  TRAVEL_DOCS_POST,
  TRAVEL_INSURANCE_COVER_GENIUS,
  TRAVEL_INSURANCE_INSIDE_EU,
  TRAVEL_INSURANCE_OUTSIDE_EU,
  TRIP_CANCELLATION_PROTECTION
};
export { getAvailabilityList, getCartAvailability, getUpsellProps, ProductCardLayoutType, validateFastTrackAvailabilityTranslation, validateLoungeAvailabilityTranslation, withParseAvailability };
export { SELECTBOX_VALUE, BAGGAGE_VALUES };
export { getTranslatedTexts };
//# sourceMappingURL=index.js.map